import { categories } from "@/mocks/comics";

const navLinks = [
  { label: "首页", href: "#home" },
  { label: "热门推荐", href: "#hot" },
  { label: "分类浏览", href: "#category" },
  { label: "追更专区", href: "#follow" },
  { label: "关于我们", href: "#about" },
  { label: "常见问题", href: "#faq" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-foreground-900 halftone-light">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center shadow-comic-sm">
                <i className="ri-emotion-happy-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-background-50 text-xl">开心漫画网</span>
            </div>
            <p className="text-background-200/80 text-sm mt-3 leading-relaxed max-w-md">
              专供无厘头脑洞与奇葩剧情的沙雕漫画社区，神转折一话接一话，魔性画风搭配爆笑展开。
              每日精选更新，点开就能收获快乐。
            </p>
            <div className="flex items-center gap-2 mt-4">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-bilibili-fill"].map((icon) => (
                <a
                  key={icon}
                  href="#home"
                  aria-label="关注开心漫画网社交账号"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-950/40 text-background-200 hover:bg-primary-500 hover:text-background-50 transition"
                >
                  <i className={icon} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          {/* Nav */}
          <div>
            <h4 className="font-heading text-background-50 mb-3">站点导航</h4>
            <ul className="flex flex-col gap-2">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-background-200/80 text-sm hover:text-secondary-300 transition">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading text-background-50 mb-3">漫画分类</h4>
            <ul className="flex flex-col gap-2">
              {categories.map((c) => (
                <li key={c.key}>
                  <a href="#category" className="text-background-200/80 text-sm hover:text-secondary-300 transition">
                    {c.name}漫画
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-300/70 text-xs">
            © 2026 开心漫画网 · 沙雕漫画在线追更
          </p>
          <p className="text-background-300/70 text-xs">
            让快乐不止一话 · 投稿邮箱 feedback@kaixinmanhua.example
          </p>
        </div>
      </div>
    </footer>
  );
}